import React, { useState } from "react";
import { db } from "../../firebaseConfig";
import { toStorageDate } from "../../utils/date";
import {
  collection,
  addDoc,
  serverTimestamp,
  getDocs,
  query,
  where,
  limit,
} from "firebase/firestore";

const AdminAddAbonament = () => {
  const [form, setForm] = useState({
    dataInceput: "",
    dataFinal: "",
    nume: "",
    email: "",
    telefon: "",
    tipTraseu: "MAI",
    format: "Online",
    planAlimentar: "Fara plan",
  });

  const [popup, setPopup] = useState({ show: false, message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "format") {
      setForm((prev) => ({
        ...prev,
        format: value,
        planAlimentar: value === "Fizic" ? "Cu plan" : "Fara plan",
      }));
      return;
    }
    setForm({ ...form, [name]: value });
  };

  const findUserByEmail = async (rawEmail) => {
    const trimmed = (rawEmail || "").trim();
    const email = trimmed.toLowerCase();
    if (!email) return null;

    let snap = await getDocs(
      query(collection(db, "users"), where("email", "==", email), limit(1))
    );

    if (snap.empty && trimmed && trimmed !== email) {
      snap = await getDocs(
        query(collection(db, "users"), where("email", "==", trimmed), limit(1))
      );
    }

    if (snap.empty) {
      const allSnap = await getDocs(collection(db, "users"));
      const match = allSnap.docs.find((docSnap) => {
        const value = (docSnap.data()?.email || "").trim().toLowerCase();
        return value === email;
      });
      if (!match) return null;
      const data = match.data() || {};
      return {
        uid: data.uid || match.id,
        name: data.displayName || data.name || "",
        email,
      };
    }

    const docSnap = snap.docs[0];
    const data = docSnap.data() || {};
    return {
      uid: data.uid || docSnap.id,
      name: data.displayName || data.name || "",
      email,
    };
  };

  const handleSubmit = async () => {
    try {
      const emailValue = (form.email || "").trim();
      const emailLower = emailValue.toLowerCase();
      const dataInceputValue = toStorageDate(form.dataInceput);
      const dataFinalValue = toStorageDate(form.dataFinal);
      if (
        !form.nume ||
        !emailValue ||
        !form.telefon ||
        !dataInceputValue ||
        !dataFinalValue ||
        !form.tipTraseu ||
        !form.format ||
        !form.planAlimentar
      ) {
        alert("Completează toate câmpurile!");
        return;
      }

      let linkedUser = null;
      try {
        linkedUser = await findUserByEmail(emailLower);
      } catch (err) {
        console.error("Eroare la cautarea utilizatorului:", err);
      }

      await addDoc(collection(db, "abonamente"), {
        ...form,
        dataInceput: dataInceputValue,
        dataFinal: dataFinalValue,
        tipTraseu: (form.tipTraseu || "").toUpperCase(),
        email: emailLower,
        userId: linkedUser?.uid || null,
        userName: linkedUser?.name || null,
        createdAt: serverTimestamp(),
      });

      // ✅ Afișăm pop-up-ul de confirmare
      setPopup({
        show: true,
        message: linkedUser
          ? "Abonament adaugat. Utilizator gasit."
          : "Abonament adaugat. Utilizator negasit.",
      });
      setTimeout(() => setPopup({ show: false, message: "" }), 3000);

      // reset formular
      setForm({
        dataInceput: "",
        dataFinal: "",
        nume: "",
        email: "",
        telefon: "",
        tipTraseu: "MAI",
        format: "Online",
        planAlimentar: "Fara plan",
      });
    } catch (error) {
      console.error("❌ Eroare Firebase:", error);
      alert("Eroare la salvarea abonamentului!");
    }
  };

  return (
    <div className="admin-card admin-abonamente admin-card-compact admin-card-compact-abonament relative">
      <h3 className="admin-card-header">Adaugă abonament</h3>
      <div className="admin-card-grid-2">
        <div className="admin-field">
          <label className="admin-label">Data început</label>
          <input
            type="date"
            className="admin-input"
            name="dataInceput"
            value={form.dataInceput}
            onChange={handleChange}
          />
        </div>
        <div className="admin-field">
          <label className="admin-label">Data final</label>
          <input
            type="date"
            className="admin-input"
            name="dataFinal"
            value={form.dataFinal}
            onChange={handleChange}
          />
        </div>
        <div className="admin-field">
          <label className="admin-label">Nume</label>
          <input
            className="admin-input"
            name="nume"
            value={form.nume}
            onChange={handleChange}
            placeholder="Popescu Andrei"
          />
        </div>
        <div className="admin-field">
          <label className="admin-label">Email</label>
          <input
            type="email"
            className="admin-input"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="exemplu@email.com"
          />
        </div>
        <div className="admin-field">
          <label className="admin-label">Telefon</label>
          <input
            className="admin-input"
            name="telefon"
            value={form.telefon}
            onChange={handleChange}
            placeholder="07xxxxxxxx"
          />
        </div>
        <div className="admin-field">
          <label className="admin-label">Format</label>
          <select
            className="admin-select"
            name="format"
            value={form.format}
            onChange={handleChange}
          >
            <option value="Online">Online</option>
            <option value="Fizic">Fizic</option>
          </select>
        </div>
        <div className="admin-field">
          <label className="admin-label">Categorie</label>
          <select
            className="admin-select"
            name="tipTraseu"
            value={form.tipTraseu}
            onChange={handleChange}
          >
            <option value="MAI">MAI</option>
            <option value="MAPN">MAPN</option>
            <option value="ISU">ISU</option>
            <option value="ANP">ANP</option>
          </select>
        </div>
        <div className="admin-field">
          <label className="admin-label">Plan alimentar</label>
          <select
            className="admin-select"
            name="planAlimentar"
            value={form.planAlimentar}
            onChange={handleChange}
          >
            <option value="Fara plan">Fara plan</option>
            <option value="Cu plan">Cu plan</option>
          </select>
        </div>
      </div>

      <button className="admin-button" onClick={handleSubmit}>
        Adaugă
      </button>

      {/* POP-UP DE CONFIRMARE */}
      {popup.show && (
        <div className="admin-popup">{popup.message}</div>
      )}
    </div>
  );
};

export default AdminAddAbonament;
